'use client';

import React, { Component } from 'react';
import { withAppRouter } from '@/legacy/withAppRouter';

import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { 
	CHECKOUT_STEP_BUYLIST_ADDRESS, 
	CHECKOUT_STEP_BUYLIST_LOCATION,
	CHECKOUT_STEP_BUYLIST_SELECT_PAYMENT_METHOD, 
} from '@/constants/checkout';
import { ERROR_CHECKOUT_BUYLIST_CONFIRMATION } from '@/constants/errors';
import {
	TX_CHECKOUT_BUYLIST_CONFIRMATION_AGREEMENT,
	TX_CHECKOUT_BUYLIST_NEXT_STEPS,
	TX_CHECKOUT_BUYLIST_STEP_BRING,
	TX_CHECKOUT_BUYLIST_STEP_BRING_NO_MAIL,
	TX_CHECKOUT_BUYLIST_STEP_BRING_TO,
	TX_CHECKOUT_BUYLIST_STEP_SEND,
	TX_CHECKOUT_BUYLIST_STEP_SEND_TO,
	TX_CHECKOUT_BUYLIST_STEP_SEND_PACK,
	TX_CHECKOUT_BUYLIST_STEP_SEND_DELIVER,
	TX_CHECKOUT_BUYLIST_STEP_GRADE,
	TX_CHECKOUT_BUYLIST_STEP_GRADE_INDIVIDUALLY,
	TX_CHECKOUT_BUYLIST_STEP_GRADE_CHANGE_PRICE,
	TX_CHECKOUT_BUYLIST_STEP_APPROVE,
	TX_CHECKOUT_BUYLIST_STEP_APPROVE_INDIVIDUALLY,
	TX_CHECKOUT_BUYLIST_STEP_PAY,
	TX_CHECKOUT_BUYLIST_STEP_PAY_PAYMENT,
	TX_CHECKOUT_BUYLIST_STEP_PAY_RETURN,
	TX_CHECKOUT_PLACE_ORDER,
	TX_null,
} from '@/constants/strings';
import { URL_BUYLIST_SUCCESS } from '@/constants/urls';

import { Order } from '@/models/orders';
import {
	STORE_SETTING_GROUP_BUYLIST,
	STORE_SETTING_KEY_BUYLIST_ALLOW_MAIL_IN,
} from '@/models/store-setting/StoreSetting';

import { getCheckoutStepData } from '@/utils/checkout';
import { isFormValid } from '@/utils/form-validation';
import { formatServerError } from '@/utils/formatting';
import { getUrlParams } from '@/utils/request';

import Checkbox from '@/components/Input/Checkbox';

import * as checkoutActionCreators from '@/actions/checkout';
import * as userActionCreators from '@/actions/user';
const allActionCreators = Object.assign({}, checkoutActionCreators, userActionCreators);

export class CheckoutStepBuylistConfirmInput extends Component {

	constructor(props) {
		super(props);

		this.state = {

			inputConfirm: false,

			errorConfirm: '',

			placeOrderError: null,
			placeOrderPending: false,
		};

		this.shippingAddress = this.getShippingAddress();
	}

	componentDidMount() {

		// Get store data
		this.props.userFetchStore()
			.catch((errResp) => {
				if(errResp) { console.error(errResp); }
			});
	}

	getShippingAddress() {
		const stepData = getCheckoutStepData(CHECKOUT_STEP_BUYLIST_ADDRESS, this.props.checkout.stepData);
		if(stepData && stepData.data && stepData.data.shippingAddress) {
			return stepData.data.shippingAddress;
		}
		return null;
	}

	getPaymentMethod() {
		const stepData = getCheckoutStepData(CHECKOUT_STEP_BUYLIST_SELECT_PAYMENT_METHOD, this.props.checkout.stepData);
		if(stepData && stepData.data && stepData.data.paymentMethod) {
			return stepData.data.paymentMethod;
		}
		return null;
	}

	getBuylistLocation() {
		const stepData = getCheckoutStepData(CHECKOUT_STEP_BUYLIST_LOCATION, this.props.checkout.stepData);
		if(stepData && stepData.data && stepData.data.location) {
			return stepData.data.location;
		}
		return null;
	}

	validateAll() {
		const errorObj = {
			errorConfirm: this.state.inputConfirm === false ? ERROR_CHECKOUT_BUYLIST_CONFIRMATION : '',
		};
		this.setState(errorObj);
		return isFormValid(errorObj);
	}

	async handleSubmit(evt) {

		evt.preventDefault();
		if(this.validateAll()) {

			this.setState({ 
				placeOrderPending: true, 
				placeOrderError: null,
			});

			const location = this.props.user.store.multiLocation ? this.getBuylistLocation() : null;

			const paymentMethod = this.getPaymentMethod();

			const orderData = {
				shipping_address_uuid: this.shippingAddress.publicUuid,
				payment_method_uuid: paymentMethod.publicUuid,
				cart_uuid: this.props.cart.currentBuylistCart.publicUuid,
				location_uuid: location?.publicUuid || null,
				status: Order.initialBuylistStatus,
			};

			const orderResp = await this.props.checkoutPlaceBuylistOrder(orderData)
				.catch((errResp) => {
					console.error(errResp);
					this.setState({ 
						placeOrderPending: false,
						placeOrderError: formatServerError(errResp),
					});
				});
				
			if(!orderResp || !orderResp.public_uuid) { return null; }

			this.props.checkoutClearStepData();

			const uuidParams = {
				order: orderResp.public_uuid,
			}
			this.props.router.push(`${URL_BUYLIST_SUCCESS}${getUrlParams(uuidParams)}`);
		}
	}

	changeConfirmation() {
		this.setState({ inputConfirm: !this.state.inputConfirm }, () => {
			if(this.state.inputConfirm && this.state.errorConfirm) {
				this.setState({ errorConfirm: '' });
			}
		});
	}

	getMailingAddress() {
		const location = this.props.user.store.multiLocation ? this.getBuylistLocation() : null;
		return location?.address ?? this.props.user.store.address;
	}

	renderAddress() {
		return <div className='stepAddress'>
			{this.getMailingAddress().formatDefault({ includePhone: true }).map((line, i) => {
				return <div key={i} className='addressLine'>{line}</div>;
			})}
		</div>;
	}

	render() {

		const {t} = this.props;

		// Only an explicit false switches to the in-store copy (see mapStateToProps).
		const allowMailIn = this.props.allowMailIn !== false;

		return <div className={'CheckoutStepBuylistConfirmInput CheckoutStepComponent'}>
			<div className='confirmLiner'>
				<form className={'confirmBuylistForm checkoutStepInputForm singleColumn'} onSubmit={this.handleSubmit.bind(this)}>
					<div className='checkoutFormSubheader'>{t(TX_CHECKOUT_BUYLIST_NEXT_STEPS)}</div>
					<div className='stepsWrapper'>
						{allowMailIn ?
							<div className='stepElement'>
								<div className='stepHeader'>{t(TX_CHECKOUT_BUYLIST_STEP_SEND, { storeName: process.env.NEXT_PUBLIC_WEBSITE_NAME })}</div>
								<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_SEND_TO)}</div>
								{this.renderAddress()}
								<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_SEND_PACK)}</div>
								<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_SEND_DELIVER)}</div>
							</div> :
							<div className='stepElement'>
								<div className='stepHeader'>{t(TX_CHECKOUT_BUYLIST_STEP_BRING, { storeName: process.env.NEXT_PUBLIC_WEBSITE_NAME })}</div>
								<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_BRING_TO)}</div>
								{this.renderAddress()}
								<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_BRING_NO_MAIL)}</div>
							</div>
						}
						<div className='stepElement'>
							<div className='stepHeader'>{t(TX_CHECKOUT_BUYLIST_STEP_GRADE, { storeName: process.env.NEXT_PUBLIC_WEBSITE_NAME })}</div>
							<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_GRADE_INDIVIDUALLY)}</div>
							<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_GRADE_CHANGE_PRICE)}</div>
						</div>
						<div className='stepElement' style={{ display: 'none' }}>
							<div className='stepHeader'>{t(TX_CHECKOUT_BUYLIST_STEP_APPROVE)}</div>
							<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_APPROVE_INDIVIDUALLY)}</div>
						</div>
						<div className='stepElement'>
							<div className='stepHeader'>{t(TX_CHECKOUT_BUYLIST_STEP_PAY)}</div>
							<div className='stepUl' style={{ display: 'none' }}>{t(TX_CHECKOUT_BUYLIST_STEP_PAY_PAYMENT)}</div>
							<div className='stepUl'>{t(TX_CHECKOUT_BUYLIST_STEP_PAY_RETURN)}</div>
						</div>
					</div>
					<div className={this.state.placeOrderError || this.state.errorConfirm ? 'checkoutFormServerError present' : 'checkoutFormServerError'}>
						<div className='FlexCenter'>{t(this.state.placeOrderError || this.state.errorConfirm || TX_null)}</div>
					</div>
					<div className={'checkoutFormConfirmLine checkoutFormInput fullWidth'}>
						<div className='checkboxInputWrapper'>
							<div className='checkboxInput'>
								<Checkbox 
								name={t(TX_CHECKOUT_BUYLIST_CONFIRMATION_AGREEMENT)}
								id={'confirmBuylistInput'}
								value={'confirm-buylist'}
								checked={this.state.inputConfirm}
								error={this.state.errorConfirm}
								onChange={this.changeConfirmation.bind(this)} />
							</div>
							<label 
								htmlFor={'confirmBuylistInput'}
								className={`checkboxLabel${this.state.errorConfirm ? ' error' : ''}`}>
								{t(TX_CHECKOUT_BUYLIST_CONFIRMATION_AGREEMENT)}
							</label>
						</div>
					</div>
					<div className={'checkoutFormInput checkoutFormAction'}>
						<button 
							className='checkoutFormButton'
							disabled={this.state.placeOrderPending}>
							{t(TX_CHECKOUT_PLACE_ORDER)}
						</button>
					</div>
				</form>
				
			</div>
		</div>;
	}
}

export function mapStateToProps(state) {
	// Stores can turn off mail-in buylist orders ("In store only"), in which case
	// the drop-off copy tells customers to bring products in person. An absent
	// setting (not loaded yet, or not seeded) keeps the default: mail in allowed.
	const settingsMap = (state.store && state.store.settings) || {};
	const setting = settingsMap[`${STORE_SETTING_GROUP_BUYLIST}.${STORE_SETTING_KEY_BUYLIST_ALLOW_MAIL_IN}`];

	return {
		allowMailIn: setting ? setting.getEffectiveBooleanValue() : true,
		cart: state.cart, 
		checkout: state.checkout,
		user: state.user,
	};
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(withAppRouter(CheckoutStepBuylistConfirmInput)));